import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {InvoiceType} from "../dto/invoice-type";
import {Observable} from "rxjs";
import {DataListModel} from "../models/data-list-model";
import {PushNotificationReminderType} from "../dto/push-notification-reminder-type";
import {PaymentEmailReminderType} from "../dto/payment-email-reminder-type";
import {EPushNotificationReminderType} from "../dto/reminder-type";

@Injectable({
  providedIn: "root"
})
export class PushNotificationReminderTypeService {
  readonly apiPath = 'push-notification-reminder-types/';

  constructor(
    private http: HttpClient,
  ) {
  }

  getReminderTypes(type: EPushNotificationReminderType): Observable<DataListModel<PushNotificationReminderType>> {
    const params = new HttpParams().set("type", type.toString());
    return this.http.get(this.apiPath, {params}) as Observable<DataListModel<PushNotificationReminderType>>;
  }

  addReminderType(reminderType: PushNotificationReminderType): Observable<PushNotificationReminderType> {
    return this.http.post(this.apiPath, reminderType) as Observable<PushNotificationReminderType>;
  }

  updateReminderType(reminderType: PushNotificationReminderType): Observable<PushNotificationReminderType> {
    return this.http.put(this.apiPath + reminderType.id, reminderType) as Observable<PushNotificationReminderType>;
  }

  deleteReminderType(id: number) {
    return this.http.delete(this.apiPath + id);
  }
}
